// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/promotion.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreatePromotionRuleRequest, DeletePromotionRuleRequest, EvaluatePromotionsRequest, EvaluatePromotionsResponse, GetPromotionRuleRequest, ListPromotionRulesRequest, ListPromotionRulesResponse, PromotionRule, UpdatePromotionRuleRequest } from "./promotion_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.PromotionService
 */
export const PromotionService = {
  typeName: "omnios.v1.PromotionService",
  methods: {
    /**
     * @generated from rpc omnios.v1.PromotionService.CreatePromotionRule
     */
    createPromotionRule: {
      name: "CreatePromotionRule",
      I: CreatePromotionRuleRequest,
      O: PromotionRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromotionService.UpdatePromotionRule
     */
    updatePromotionRule: {
      name: "UpdatePromotionRule",
      I: UpdatePromotionRuleRequest,
      O: PromotionRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromotionService.DeletePromotionRule
     */
    deletePromotionRule: {
      name: "DeletePromotionRule",
      I: DeletePromotionRuleRequest,
      O: PromotionRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromotionService.GetPromotionRule
     */
    getPromotionRule: {
      name: "GetPromotionRule",
      I: GetPromotionRuleRequest,
      O: PromotionRule,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromotionService.ListPromotionRules
     */
    listPromotionRules: {
      name: "ListPromotionRules",
      I: ListPromotionRulesRequest,
      O: ListPromotionRulesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromotionService.EvaluatePromotions
     */
    evaluatePromotions: {
      name: "EvaluatePromotions",
      I: EvaluatePromotionsRequest,
      O: EvaluatePromotionsResponse,
      kind: MethodKind.Unary,
    },
  }
};

